import { defineNuxtPlugin } from "#app"
import axios from "@evercam/shared/api/client/axios"
import { OnRequestExpiredTokenInterceptor } from "@evercam/shared/api/client/interceptors"

export default defineNuxtPlugin((nuxtApp) => {
  const { $auth, $errorTracker } = nuxtApp.nuxt2Context
  const {
    apiURL,
    stagingApiUrl,
    aiApiUrl,
    ingestApiUrl,
    stagingAiApiUrl,
    posthogApiUrl,
    posthogProjectId,
    posthogPrivateApiKey,
    firebaseVideowallUrl,
    weatherApiBaseUrl,
    evercamLabsUrl,
    snapshotsURL,
    firebaseDbLink,
  } = nuxtApp.$config.public

  const isStaging = window.location.hostname.includes("staging")
  axios.addEnvironmentVariables({
    baseUrl: isStaging ? stagingApiUrl : apiURL,
    aiApiUrl: isStaging ? stagingAiApiUrl : aiApiUrl,
    ingestApiUrl,
    stagingAiApiUrl,
    posthogApiUrl,
    posthogProjectId,
    posthogPrivateApiKey,
    firebaseVideowallUrl,
    weatherApiBaseUrl,
    evercamLabsUrl,
    snapshotsURL,
    firebaseDbLink,
    getAuthToken: () => $auth.getToken(),
    errorLogger: $errorTracker.leaveBreadcrumb,
    isStaging,
  })

  const onRequest = (request) =>
    OnRequestExpiredTokenInterceptor(
      request,
      () => $auth?.hasToken() && $auth?.isTokenExpired(),
      $auth?.logout
    )

  axios.addRequestInterceptor(onRequest)
})
